const DRAFT_SAVED_AT_KEY_PREFIX = 'draftSavedAt:';

export const getDraftSavedAtKey = (draftKey: string): string =>
  `${DRAFT_SAVED_AT_KEY_PREFIX}${draftKey}`;

export function recordDraftSaved(draftKey: string): void {
  localStorage.setItem(getDraftSavedAtKey(draftKey), String(Date.now()));
}
